import React from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  name: (props) => ({
    borderRadius: '50%',
    backgroundColor: props.backgroundColor,
    width: props.size,
    height: props.size,
    lineHeight: `${props.size}px`,
    textAlign: 'center',
    color: theme.palette.common.white,
    fontWeight: 'bold',
  }),
}));

export const Initial = (props) => {
  const classes = useStyles(props);
  const { text, variant } = props;
  return (
    <Typography variant={variant || 'h5'} className={classes.name}>
      {text}
    </Typography>
  );
};
